import ExcelJS from 'exceljs'
import saveAs from 'file-saver'
import { maocData } from './MaocData'
import i18n from '../i18n'

export const ExcelExport = {
  MAX_EXCEL_COLUMN: 16384,

  exportExcelCrewManifest: function (data, filename = 'crew-manifest') {
    const workbook = new ExcelJS.Workbook()
    const ws = workbook.addWorksheet('Crew')
    ws.properties.defaultColWidth = 25

    const titleData = [
      i18n.t('given_names_&_surnames'),
      i18n.t('date_of_birth') + ' (dd/mm/yyyy)',
      i18n.t('nationality'),
      i18n.t('rank'),
      i18n.t('document_type'),
      i18n.t('document_number')
    ]

    var addCrewRow = function (ws, crewmember, rules) {
      const rowData = [
        crewmember.name,
        crewmember.birthdate,
        (crewmember.nationality) ? i18n.t('countries.' + crewmember.nationality) : undefined,
        (crewmember.rank) ? i18n.t('ranks.' + crewmember.rank) : undefined,
        (crewmember.document_type) ? i18n.t('documents.' + crewmember.document_type) : undefined,
        crewmember.document_number
      ]

      const row = ws.addRow(rowData)

      addDateValidationToCell(row.getCell(2))
      addValidationToCell(ws, row.getCell(3), rules.countries)
      addValidationToCell(ws, row.getCell(4), rules.ranks)
      addValidationToCell(ws, row.getCell(5), rules.documents)
    }

    var addInputValidation = function (inputs) {
      var data = []
      inputs.forEach(function (input) {
        input.forEach(function (item, index) {
          if (data[index] === undefined) {
            data[index] = []
          }
          data[index].push(item.value)
          data[index].push(i18n.t(item.text))
        })
      })

      return data
    }

    var validationRule = function (offset, length) {
      const char = String.fromCharCode('A'.charCodeAt(0) + offset * 2 + 1)
      return 'Validation!$' + char + '$1' + ':$' + char + '$' + (length + 1)
    }

    var addDateValidationToCellByKey = function (ws, key, date = new Date()) {
      addDateValidationToCell(ws.getCell(key), date)
    }

    var addDateValidationToCell = function (cell) {
      cell.dataValidation = {
        type: 'custom',
        showErrorMessage: true,
        error: 'Must be a valid date in DD/MM/YYYY format between 1900-01-01 and today',
        allowBlank: false,
        formulae: [
          'AND(' +
            'LEN(B2)=10,' +
            'MID(B2,3,1)="/",' +
            'MID(B2,6,1)="/",' +
            'ISNUMBER(--LEFT(B2,2)),' +
            'ISNUMBER(--MID(B2,4,2)),' +
            'ISNUMBER(--RIGHT(B2,4)),' +
            '--LEFT(B2,2)=DAY(DATE(--RIGHT(B2,4),--MID(B2,4,2),--LEFT(B2,2))),' +
            '--MID(B2,4,2)=MONTH(DATE(--RIGHT(B2,4),--MID(B2,4,2),--LEFT(B2,2))),' +
            '--RIGHT(B2,4)=YEAR(DATE(--RIGHT(B2,4),--MID(B2,4,2),--LEFT(B2,2))),' +
            'DATE(--RIGHT(B2,4),--MID(B2,4,2),--LEFT(B2,2))>=DATE(1900,1,1),' +
            'DATE(--RIGHT(B2,4),--MID(B2,4,2),--LEFT(B2,2))<=TODAY()' +
          ')'
        ]
      }
    }

    var addValidationToCellByKey = function (ws, key, rule) {
      const cell = ws.getCell(key)
      addValidationToCell(ws, cell, rule)
    }

    var addValidationToCell = function (ws, cell, rule) {
      cell.dataValidation = {
        type: 'list',
        allowBlank: false,
        showErrorMessage: true,
        formulae: [rule]
      }

      // cell.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'F08080' }
      // }
    }

    const countries = maocData.dynamicLocalizedSelect('countries')
    const ranks = maocData.dynamicLocalizedSelect('ranks')
    const documents = maocData.dynamicLocalizedSelect('documents')

    var inputData = addInputValidation([countries, ranks, documents], i18n)
    const wsValidation = workbook.addWorksheet('Validation')
    wsValidation.state = 'hidden'

    inputData.forEach(function (item) {
      wsValidation.addRow(item)
    })

    const countriesRule = validationRule(0, countries.length)
    const ranksRule = validationRule(1, ranks.length)
    const documentsRule = validationRule(2, documents.length)
    const rules = {
      countries: countriesRule,
      ranks: ranksRule,
      documents: documentsRule
    }

    const titleRow = ws.addRow(titleData)
    titleRow.font = { bold: true }

    data.forEach(function (crewmember) {
      addCrewRow(ws, crewmember, rules)
    })

    for (var i = 2; i < 100; i++) {
      addDateValidationToCellByKey(ws, 'B' + i)
      addValidationToCellByKey(ws, 'C' + i, countriesRule)
      addValidationToCellByKey(ws, 'D' + i, ranksRule)
      addValidationToCellByKey(ws, 'E' + i, documentsRule)
    }

    ws.getColumn(2).numFmt = '@' // Set date column to text format to avoid Excel date conversion issues
    ws.getColumn(2).width = 25 // Set width for date column

    for (var j = ws.actualColumnCount + 1; j < ExcelExport.MAX_EXCEL_COLUMN + 1; j++) {
      const col = ws.getColumn(j)
      col.hidden = true
    }

    workbook.xlsx.writeBuffer().then((buf) => {
      saveAs(new Blob([buf]), this.generateFilename(filename, i18n.locale))
    })
  },

  generateFilename: function (prefix, locale) {
    return prefix + '-' + locale + '.xlsx'
  }
}

export const ExcelImport = {
  readExcelFile: function (excelFile, callback) {
    const wb = new ExcelJS.Workbook()
    const reader = new FileReader()

    reader.readAsArrayBuffer(excelFile)
    reader.onload = function () {
      const buffer = reader.result
      wb.xlsx.load(buffer).then(function (workbook) {
        const ws = workbook.getWorksheet('Crew')
        const wsLookup = workbook.getWorksheet('Validation')
        var data = ExcelImport.loadCrewData(ws, wsLookup)
        callback(data)
      })
    }
  },

  loadCrewData: (ws, wsLookup) => {
    var crew = []
    ws.eachRow(function (row, index) {
      if (index > 1) {
        var crewMember = row.values.slice()
        crewMember[2] = ExcelImport.parseDateFromCellValue(row.values[2])
        crewMember[3] = ExcelImport.lookupValueKey(wsLookup, 2, row.values[3])
        crewMember[4] = ExcelImport.lookupValueKey(wsLookup, 4, row.values[4])
        crewMember[5] = ExcelImport.lookupValueKey(wsLookup, 6, row.values[5])
        crewMember.shift()
        crew.push(crewMember)
      }
    })

    return crew
  },

  getRowIndexByColumnValue: (worksheet, index, value) => {
    var match
    const col = worksheet.getColumn(index)
    col.eachCell(function (cell, index) {
      if (cell.value === value) {
        match = index
      }
    })
    return match
  },

  lookupValueKey: (ws, searchColIndex, value) => {
    if (value === undefined) {
      return ''
    }

    var colChar = String.fromCharCode('A'.charCodeAt(0) + searchColIndex - 2)
    const idx = ExcelImport.getRowIndexByColumnValue(ws, searchColIndex, value)
    return ws.getCell(colChar + idx).value
  },

  parseDateFromCellValue: (value) => {
    if (value instanceof Date) {
      const day = value.getUTCDate().toString().padStart(2, '0')
      const month = (value.getUTCMonth() + 1).toString().padStart(2, '0')
      const year = value.getUTCFullYear()
      return `${day}/${month}/${year}`
    } else {
      return value
    }
  }
}
